import React from 'react';
import { connect } from 'unistore/react';
import Link from 'next/link';
import { format as dateFormat, formatISO } from 'date-fns';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// import Chart from '../bb-components/charts';
// import TradeTable from '../bb-components/trade-table';
import { CoinsList } from '../bb-components/bb-coinlistView';
import BbPpDashboard from '../bb-components/bb-pricePage__dashboard';
import { SEO, MarkdownComponents } from '@components';

import { tickerActions } from '@utils/store/actions';
import { moneyFormatter } from '@utils/customLib';
import { getINRDecimals, getCoinProperty } from '@utils/params';
import { getRate } from '@utils/storeUtils';

// const illustrations = require.context(
// 	'cryptocurrency-icons/32@2x/icon/',
// 	true,
// 	/\.(png)$/
// );

class PricePages extends React.Component {
	state = {
		plotData: [],
	};

	constructor(props) {
		super(props);
		const { /* tickerData, */ graphPoints /* __fillStaticRates */ } = props;
		// if (tickerData) {
		// 	// __fillStaticRates(tickerData);
		// }

		if (graphPoints && graphPoints.length > 0) {
			this.state = {
				plotData: graphPoints,
			};
		}
	}

	render() {
		const {
			content,
			title,
			description,
			heading,
			path,
			coin,
			coinName,
			showPrice,
			showGraph,
			coinPrice,
		} = this.props;
		const { plotData } = this.state;

		let coinIcon = false;
		switch (coin.toLowerCase()) {
			case 'sia':
				coinIcon =
					'https://bitbns.com/assets/img/coinIcons/icon/sc.svg';
				break;
			case 'xrb':
				coinIcon =
					'https://bitbns.com/assets/img/coinIcons/icon/nano.svg';
				break;
			case 'pac':
				coinIcon =
					'https://bitbns.com/assets/img/coinIcons/icon/$pac.svg';
				break;
			case 'nexo':
			case 'efx':
			case 'cpx':
			case 'loom':
			case 'qkc':
			case 'eosd':
			case 'xrp':
			case 'npxs':
			case 'ram':
			case 'let':
			case 'soul':
				coinIcon = getCoinProperty(coin, 'coinIcon');
				break;
			case 'dct':
			case 'onion':
			case 'dime':
			case 'ioc':
			case 'moon':
			case 'xspec':
			case 'vox':
			case 'xwc':
			case 'dmd':
			case 'thc':
			case 'flash':
				coinIcon = false;
				break;
			default:
				coinIcon = `https://bitbns.com/assets/img/coinIcons/icon/${coin.toLowerCase()}.svg`;
		}
		const price = moneyFormatter(
			getRate(coin).lastTradePrice || coinPrice,
			{
				minimumFractionDigits: 0,
				maximumFractionDigits: getINRDecimals(coin),
			}
		);
		const newTitle =
			coin === 'BTC'
				? `${title} today ₹${price} | Bitcoin price INR`
				: title;
		const url = `https://bitbns.com${path}/`;

		return (
			<>
				<SEO
					title={newTitle}
					url={url}
					description={description}
					image={coinIcon}
					jsonLd={[
						`  {
								"@context": "https://schema.org",
								"@type": "Article",
								"mainEntityOfPage": {
									"@type": "WebPage",
									"@id": "${url}"
								},
								"headline": "${newTitle}",
								"datePublished": "2018-01-01T08:00:00+08:00",
								"dateModified": "${formatISO(new Date())}",
								"author": {
									"@type": "Organization",
									"name": "Bitbns"
								}, "image": [
									"https://bitbns.com/img/logos/bns-512.png"
								],
								"publisher": {
									"@type": "Organization",
									"name": "Bitbns",
									"logo": {
									"@type": "ImageObject",
									"url": "https://bitbns.com/img/logos/bns-144.png"
									}
								},
								"description": "${description}"
								}`,
					]}
				/>

				<div className="bg-primary text-white py-8">
					<div className="container">
						<h1 className="flex items-center justify-center text-3xl font-bold my-0 text-left">
							{coinIcon && (
								<img
									src={coinIcon}
									width="64"
									height="64"
									className="inline-block align-middle mr-4"
									alt={`${coinName} Price`}
								/>
							)}{' '}
							{heading}
						</h1>
					</div>
				</div>

				<CoinsList price up singleLine coin={coin.toLowerCase()} />
				<div className="bg-white px-4 ">
					<div className="max-w-6xl mx-auto py-16">
						{showPrice !== 0 && (
							<div className="max-w-6xl mx-auto mb-12">
								<div className="u-text-spacing--1 text-lightGray text-sm">
									1 {coin} =<br />
									<strong className="text-xl text-dharkyBhicky">
										&#8377;
										{price}
									</strong>
								</div>
								{coin.toLowerCase().match(/^(ram)$/) && (
									<>
										Also check in USD -{' '}
										<Link
											href={`${
												path.split(
													'-price-inr-india'
												)[0]
											}-price-usd/`}
											className="font-bold c-links"
										>
											EOS RAM price in USD
										</Link>
									</>
								)}
								{coin !== 'TRX' ? (
									<div className="my-2">
										{coinName} price today -{' '}
										<em>
											As on{' '}
											<span
												itemScope=""
												itemType="http://schema.org/CreativeWork"
											>
												<span
													itemProp="dateModified"
													content={dateFormat(
														new Date(),
														'yyyy-MM-dd'
													)}
												>
													{' '}
													{dateFormat(
														Date.now(),
														"EEEE do 'of' MMMM yyyy h:mm:ss a"
													)}
												</span>
											</span>
										</em>
									</div>
								) : (
									<div className="leading-relaxed my-2">
										<strong>
											{coinName} ({coin}) to INR
										</strong>{' '}
										at its best price on Bitbns.
										<br />
										Check here for Offers and{' '}
										<strong>
											{coinName} price in India Today.
										</strong>
										<br />
										Get complete {coinName} Price Chart
										details here.
									</div>
								)}
								{coin !== 'XRP' ? (
									<>
										Start Trading Now &rarr;{' '}
										<Link
											href={`${
												path.split(
													'-price-inr-india'
												)[0]
											}/`}
										>
											<a className="font-bold c-links">
												Buy {coinName}{' '}
												{!coin
													.toLowerCase()
													.match(/^(ram)$/)
													? 'in India'
													: ''}
											</a>
										</Link>
									</>
								) : (
									<a
										href="https://bit.ly/obbxrpref7"
										className="block"
									>
										<img
											src="https://bitbns.com/assets/img/banners/banner__pricePage__freeBtc.png?"
											alt="Sign-up and Complete KYC in 5 minutes & get ₹100 worth of Bitcoins Instantly"
											className="w-full max-w-3xl rounded"
										/>
									</a>
								)}
							</div>
						)}
						{showGraph && (
							<BbPpDashboard coin={coin} plotData={plotData} />
						)}
						{/* {showGraph && (
							<div>
								<h3 className="text-lg mt-8 mb-4">
									{coinName} Price Chart
								</h3>
								<Chart
									currentTab={this.state.currentTab}
									chartData={this.state.chartData}
									coin={coin}
								/>
							</div>
						)} */}
						{/* {showTrades && (
							<div>
								<TradeTable
									currency="INR"
									plotData={this.state.plotData}
									coin={this.state.coin}
									changeCoin={this.state.changeCoin}
									entryLength={6}
									decimalDigits={getINRDecimals(coin)}
								/>
								<div className="text-center">
									<Button
										href="/trade/#/signup"
										size="big"
										triangle="right"
									>
										Buy {coinName} in India
									</Button>
								</div>
							</div>
						)} */}
						<div className="mx-auto u-para--readable">
							<ReactMarkdown
								components={MarkdownComponents}
								remarkPlugins={[remarkGfm]}
							>
								{content}
							</ReactMarkdown>
						</div>
					</div>
				</div>
				<CoinsList buy />
			</>
		);
	}
}

export default connect(
	'currentRate, currentTradingCoin',
	tickerActions
)(PricePages);
